const environments = {
  development: {
    apiUrl: "http://localhost:8000/api",
    timeout: 10000,
    enableMock: true, // Enable mock API in development
  },
  staging: {
    apiUrl: "https://staging-api.example.com",
    timeout: 15000,
    enableMock: false,
  },
  production: {
    apiUrl: "https://api.example.com",
    timeout: 30000,
    enableMock: false,
  },
};

// Get environment from Vite env variables or default to development
const currentEnv = import.meta.env.VITE_APP_ENV || "development";

export default environments[currentEnv];
